@if (showRetryAction) {
  <ion-content class="app-home retry-state">
    <div class="wings-splash-header">
      <h2 class="header-title">{{ "check-splash.Checking" | translate }}</h2>
      <p>{{ timeoutRetryMessage }}</p>
    </div>
    <ion-button expand="block" class="action-btn-large" (click)="retryCheckWinnings()">
      {{ "check-winnings.try_again" | translate }}
    </ion-button>
    <ion-button expand="block" fill="clear" (click)="goBackToSyndicate()">
      {{ "check-winnings.syndicate" | translate }}
    </ion-button>
  </ion-content>
} @else if (claimableSyndicates$ | async) {
  <ion-content class="app-home">
    @if (!allCardAnimationDone) {
      <div class="wings-splash-header">
        <h2 class="header-title">{{ "check-splash.Checking" | translate }}</h2>
      </div>
    }
    <div [@slideInUp]="sliderUpAnimation ? 'upside' : 'downside'">
      @for (cardData of cardDetails?.syndicate_group; track cardData; let cardIndexNumber = $index) {
        <ion-card
          class="card"
          [@slideOutLeft]="cardData.removeEntireCard ? 'removed' : ''"
          [@reduceHeight]="cardData.reduceHeight ? 'reduce' : ''"
          >
          <ion-thumbnail class="thumbnail-wrap">
            <div class="img-overlay"></div>
            <img src="{{ cardData?.image_url }}" class="cover-img" alt="cover-img" />
            <div class="cover-img-title">{{ cardData?.syndicate_name | uppercase }}</div>
          </ion-thumbnail>
          <div class="card-content">
            @if (!(cardData?.removedSubTitleCard && cardData?.bottomTextVisible)) {
              <ion-row
                class="inner-box"
          [@slideOutLeftForChildBox]="
            cardData.removedSubTitleCard
              ? cardData?.removedSubTitleCard && cardData?.bottomTextVisible
                ? 'hide-content'
                : 'removed'
              : ''
          "
                >
                <ion-col size="2" class="card-ic"> </ion-col>
                <ion-col size="7" class="card-title">
                  <h1 class="title-wrap">{{ cardData?.product_name }} {{ cardData?.draw_day }}</h1>
                </ion-col>
                <ion-col size="3" class="select-box">
                  <div [ngClass]="cardIndexNumber !== 0 ? 'check-circle' : 'hide-content'">
                    <input class="label__checkbox" type="checkbox" />
                    <span class="label__text">
                      <span class="label__check">
                        <ion-icon name="checkmark-outline" class="tickmark-icon"></ion-icon>
                      </span>
                    </span>
                  </div>
                  <div [ngClass]="cardIndexNumber === 0 && tickMark === 0 ? 'check-circle' : 'hide-content'">
                    <input class="label__checkbox" type="checkbox" [checked]="cardIndexNumber === 0 && firstCardCheck" />
                    <span class="label__text">
                      <span class="label__check">
                        <ion-icon name="checkmark-outline" class="tickmark-icon"></ion-icon>
                      </span>
                    </span>
                  </div>
                  <div class="round-size" [ngClass]="cardIndexNumber === 0 && tickMark === 1 ? '' : 'hide-content'">
                    <div class="green-zoom-animation-1"></div>
                    <div class="green-zoom-animation-2"></div>
                  </div>
                </ion-col>
              </ion-row>
            }
            <ion-row class="msg-wrap" [ngClass]="cardData.bottomTextVisible ? '' : 'hide-content'">
              <h4 class="checked-msg">{{ "check-splash.All" | translate }}</h4>
            </ion-row>
          </div>
        </ion-card>
      }
      <audio #myAudio src="assets/audio/check_winning_sound.mp3" muted></audio>
      @if (allCardAnimationDone) {
        <div class="sucess-checked" [@fadeText]="allCardAnimationDone ? 'normal' : 'blur'">
          @if (checkTicketStatus) {
            <h2 class="header-title">{{'check-splash.Check_tickets' | translate}}</h2>
          }
          @if (!checkTicketStatus) {
            <h2 class="header-title">{{'check-splash.checked' | translate}}</h2>
          }
          <img src="assets/gif/check-winnings-tick.gif" class="success-checked-gif" (load)="ticketStatus()" />
        </div>
      }
    </div>
  </ion-content>
} @else {
  <app-loading class="loading-screen"></app-loading>
}

